export const ACTION_GET_RECOVERFORGOTTENPASSWORD = 'ACTION_GET_RECOVERFORGOTTENPASSWORD';
export const ACTION_POST_VALIDATETOKEN = 'ACTION_POST_VALIDATETOKEN';
export const ACTION_GET_RESENDTOKEN = 'ACTION_GET_RESENDTOKEN';